import HighlightBlock from "./HighlightBlock";

export default HighlightBlock;
